"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionnaireBuilderSeeds = void 0;
const fieldTypes_1 = require("../../../types/carrierQuestionnaire/fieldTypes");
const validations_1 = require("../../validations");
const NodeIndexer_1 = require("./NodeIndexer");
const questionnaireLevels = {
    sectionGroup: 1,
    section: 2,
    subsection: 3,
};
const questionnaireBuilderSeeds = (startingIndex = 1) => {
    const questionnaireNodeIndexer = new NodeIndexer_1.NodeIndexer(Object.keys(questionnaireLevels).length, startingIndex);
    return {
        forSectionGroup: () => {
            const index = questionnaireNodeIndexer.getNextIndex(questionnaireLevels.sectionGroup);
            return {
                index,
                id: 'defaultSectionGroupId',
                title: { en: 'Default SectionGroup Title', fr: 'Default SectionGroup Title' },
                sections: [],
            };
        },
        forSection: () => {
            const index = questionnaireNodeIndexer.getNextIndex(questionnaireLevels.section);
            return {
                index,
                id: 'defaultSectionId',
                title: { en: 'Default Section Title', fr: 'Default Section Title' },
                documentTypes: [],
                subsections: [],
            };
        },
        forSubsection: () => {
            const index = questionnaireNodeIndexer.getNextIndex(questionnaireLevels.subsection);
            return {
                index,
                id: 'defaultSubsectionId',
                title: { en: 'Default Subsection Title', fr: 'Default Subsection Title' },
                fieldGroups: [],
            };
        },
        forFieldGroup: () => ({
            id: 'defaultFieldGroupId',
            title: { en: 'Default FieldGroup Title', fr: 'Default FieldGroup Title' },
            text: { en: 'Default FieldGroup Text', fr: 'Default FieldGroup Text' },
            fields: [],
        }),
        forInputField: () => ({
            id: 'defaultInputFieldId',
            nodeId: 'defaultInputFieldId',
            title: { en: 'Default Field Title', fr: 'Default Field Title' },
            text: { en: 'Default Field Text', fr: 'Default Field Text' },
            type: fieldTypes_1.FieldTypes.input,
            validation: { type: validations_1.Validations.string },
        }),
        forOptionField: () => ({
            id: 'defaultOptionFieldId',
            nodeId: 'defaultOptionFieldId',
            title: { en: 'Default Field Title', fr: 'Default Field Title' },
            text: { en: 'Default Field Text', fr: 'Default Field Text' },
            type: fieldTypes_1.FieldTypes.dropdown,
            validation: { type: validations_1.Validations.string },
            options: [{ id: 'defaultOptionId', text: { en: 'Default Text', fr: 'Default Text ' } }],
        }),
        forDynamicOptionField: (dynamicOptions) => ({
            id: 'defaultDynamicOptionFieldId',
            nodeId: 'defaultDynamicOptionFieldId',
            title: { en: 'Field Title', fr: 'Field Title' },
            text: { en: 'Field Text', fr: 'Field Text' },
            type: fieldTypes_1.FieldTypes.dropdown,
            validation: { type: validations_1.Validations.string },
            dynamicOptions,
            options: [],
        }),
        forRepeatableFieldGroupOptions: () => ({
            options: {
                repeatable: true,
                minRepetitions: 1,
                maxRepetitions: 3,
            },
            addQuestionButtonText: { en: 'Add', fr: 'Add' },
            removeQuestionButtonText: { en: 'Remove', fr: 'Remove' },
        }),
        forSignatureField: (participantRole) => ({
            id: 'signatureFieldId',
            title: { en: 'Field Title', fr: 'Titre du champ texte' },
            text: { en: 'Field Text', fr: 'Texte du champ texte' },
            type: fieldTypes_1.FieldTypes.signature,
            validation: { type: validations_1.Validations.string },
            readOnly: true,
            participantRole,
        }),
    };
};
exports.questionnaireBuilderSeeds = questionnaireBuilderSeeds;
